'use client'

import { IPlaceQuote } from '@repo/sdk'
import { useLocationInput } from '@repo/ui'
import { AutoComplete } from '@repo/ui/components'
import { AutocompleteLocation } from '@repo/ui/inputs'

interface LocationInputProps {
  onChange: (...event: any[]) => void
  value?: IPlaceQuote
}

export const LocationInput = (props: LocationInputProps) => {
  const {
    data,
    getDisplayValue,
    getSearchValue,
    handleOnChange,
    isPending,
    query,
    renderOption,
    selectedValue,
    setQuery,
  } = useLocationInput(props)

  return (
    <AutoComplete<AutocompleteLocation>
      data={data ?? []}
      emptyMessage="No locations found."
      getDisplayValue={getDisplayValue}
      getSearchValue={getSearchValue}
      isLoading={isPending}
      onSearchValueChange={setQuery}
      onSelectedValueChange={handleOnChange}
      placeholder="Search locations..."
      renderOption={renderOption}
      searchStartLength={1}
      searchValue={query}
      selectedValue={selectedValue}
    />
  )
}
